import React from 'react';
import PropTypes from 'prop-types';
import Notify from "../../services/Notify";
import Loading from "../../component/Loading/Loading";
import NodeService from "../node/NodeService";
import { Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';

class AntennaCustomSelect extends React.Component {

  service = new NodeService();

  constructor(props) {
    super(props);
    this.addOrRemoveReadPoint = this.addOrRemoveReadPoint.bind(this);
    this.state = {uuids: props.uuids || [], loading: true};
    props.setValue && props.setValue(this.state.uuids);
  }

  componentDidMount() {
    this.setState({loading: true});
    this.service.findAll(0, 999999).then(
      data => this.setState(
        {
          loading: false,
          nodes: data.content
        }),
      error => {
        const state = {loading: false};
        if (error.response.status === 404) {
          state.message = 'Entidade não encontrada!';
        } else {
          state.message = 'Erro inesperado!';
          Notify.error('Falha o buscar entidade!', error)
        }
        this.setState(state);
      }
    )
  }

  addOrRemoveReadPoint(id) {
    const {setValue} = this.props;
    const {uuids = []} = this.state;
    const position = uuids.indexOf(id);
    if (position >= 0) {
      uuids.splice(position, 1);
    } else {
      uuids.push(id);
    }
    setValue && setValue(uuids);
    this.setState({uuids});
  }

  render() {
    let {nodes, loading, uuids} = this.state;

    if (loading) {
      return <Loading/>
    }

    return (
      <ListGroup className="mb-5" style={styles.listGroupItem}>
        <Row>
          {
            nodes.map(({id, uuid, antennas, friendlyName}) => {
              return antennas && antennas.map(({uuid: antennaUuid}) => {
                const completeUuid = uuid + '.' + antennaUuid;
                const active = uuids.indexOf(completeUuid) >= 0 ? 'active' : '';

                return (
                  <Col md={6} key={id}>
                    <ListGroupItem onClick={e => { e.preventDefault(), this.addOrRemoveReadPoint(completeUuid) }} active={active} className="list-group-item-action">
                      <h5>Antena: {antennaUuid}</h5>
                      <h6>Node: {uuid}</h6>
                      <h6>Node: {friendlyName}</h6>
                    </ListGroupItem>
                  </Col>
                )
              })
            }
          )
        }
        </Row>
      </ListGroup>
    )
  }
}

const styles = {
  listGroupItem: { 
    height: '65vh', 
    overflowY: 'scroll', 
    overflowX: 'hidden' 
  }
}

AntennaCustomSelect.propTypes = {
  uuids: PropTypes.array,
  history: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default AntennaCustomSelect;



// WEBPACK FOOTER //
// ./src/gateways/antennas/AntennaCustomSelect.js